<template>
  <div :class="('page-' + this.$route.name).toLowerCase().replace(' ', '-')">
    <vue-snotify></vue-snotify>
    <modals-container></modals-container>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Index',
      // all titles will be injected into this template
      titleTemplate: '%s :: DigidoLMS'
    };
  }
};
</script>

<style lang="scss">
  // CoreUI Icons Set
  //@import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Bootstrap Vue Styles */
  //@import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>